//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';

export const STATS_ADMIN_API_BASE_URL = new InjectionToken<string>('STATS_ADMIN_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class DeliveryLogsClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(STATS_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchSesLogs(type: SesLogType, filter: SesLogSearchRequest): Observable<PagedResultDtoOfSesLogRowDto> {
        let url_ = this.baseUrl + "/admin/delivery-logs/ses/{type}/search";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSesLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSesLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSesLogRowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSesLogRowDto>;
        }));
    }

    protected processSearchSesLogs(response: HttpResponseBase): Observable<PagedResultDtoOfSesLogRowDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSesLogRowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'DeliveryLogsClient.SearchSesLogs');
            }));
        }
        return _observableOf(null as any);
    }

    searchSmsLogs(filter: TwilioSmsSearchModel): Observable<PagedResultDtoOfTwilioSmsDto> {
        let url_ = this.baseUrl + "/admin/delivery-logs/sms/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSmsLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSmsLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTwilioSmsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTwilioSmsDto>;
        }));
    }

    protected processSearchSmsLogs(response: HttpResponseBase): Observable<PagedResultDtoOfTwilioSmsDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTwilioSmsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'DeliveryLogsClient.SearchSmsLogs');
            }));
        }
        return _observableOf(null as any);
    }

    searchVoiceLogs(filter: TwilioCallSearchModel): Observable<PagedResultDtoOfTwilioCallDto> {
        let url_ = this.baseUrl + "/admin/delivery-logs/voice/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchVoiceLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVoiceLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTwilioCallDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTwilioCallDto>;
        }));
    }

    protected processSearchVoiceLogs(response: HttpResponseBase): Observable<PagedResultDtoOfTwilioCallDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTwilioCallDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'DeliveryLogsClient.SearchVoiceLogs');
            }));
        }
        return _observableOf(null as any);
    }

    dashboard(): Observable<DashboardStatsDto> {
        let url_ = this.baseUrl + "/admin/delivery-logs/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardStatsDto>;
        }));
    }

    protected processDashboard(response: HttpResponseBase): Observable<DashboardStatsDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'DeliveryLogsClient.Dashboard');
            }));
        }
        return _observableOf(null as any);
    }
}

export class PagedResultDtoOfSesLogRowDto implements IPagedResultDtoOfSesLogRowDto {
    items!: SesLogRowDto[];
    totalCount!: number;
    page!: number;
    pageSize!: number;

    constructor(data?: IPagedResultDtoOfSesLogRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SesLogRowDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSesLogRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSesLogRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedResultDtoOfSesLogRowDto {
    items: SesLogRowDto[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export class SesLogRowDto implements ISesLogRowDto {
    id!: number;
    timestamp!: Date;
    messageId!: string | undefined;
    source!: string | undefined;
    destinations!: string[];
    notificationId!: string | undefined;
    delivery!: SesDeliveryDetailsDto | undefined;
    bounce!: SesBounceDetailsDto | undefined;
    complaint!: SesComplaintDetailsDto | undefined;
    open!: SesOpenDetailsDto | undefined;
    click!: SesClickDetailsDto | undefined;

    constructor(data?: ISesLogRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.destinations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.messageId = _data["messageId"];
            this.source = _data["source"];
            if (Array.isArray(_data["destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["destinations"])
                    this.destinations!.push(item);
            }
            this.notificationId = _data["notificationId"];
            this.delivery = _data["delivery"] ? SesDeliveryDetailsDto.fromJS(_data["delivery"]) : undefined as any;
            this.bounce = _data["bounce"] ? SesBounceDetailsDto.fromJS(_data["bounce"]) : undefined as any;
            this.complaint = _data["complaint"] ? SesComplaintDetailsDto.fromJS(_data["complaint"]) : undefined as any;
            this.open = _data["open"] ? SesOpenDetailsDto.fromJS(_data["open"]) : undefined as any;
            this.click = _data["click"] ? SesClickDetailsDto.fromJS(_data["click"]) : undefined as any;
        }
    }

    static fromJS(data: any): SesLogRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new SesLogRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["messageId"] = this.messageId;
        data["source"] = this.source;
        if (Array.isArray(this.destinations)) {
            data["destinations"] = [];
            for (let item of this.destinations)
                data["destinations"].push(item);
        }
        data["notificationId"] = this.notificationId;
        data["delivery"] = this.delivery ? this.delivery.toJSON() : undefined as any;
        data["bounce"] = this.bounce ? this.bounce.toJSON() : undefined as any;
        data["complaint"] = this.complaint ? this.complaint.toJSON() : undefined as any;
        data["open"] = this.open ? this.open.toJSON() : undefined as any;
        data["click"] = this.click ? this.click.toJSON() : undefined as any;
        return data;
    }
}

export interface ISesLogRowDto {
    id: number;
    timestamp: Date;
    messageId: string | undefined;
    source: string | undefined;
    destinations: string[];
    notificationId: string | undefined;
    delivery: SesDeliveryDetailsDto | undefined;
    bounce: SesBounceDetailsDto | undefined;
    complaint: SesComplaintDetailsDto | undefined;
    open: SesOpenDetailsDto | undefined;
    click: SesClickDetailsDto | undefined;
}

export class SesDeliveryDetailsDto implements ISesDeliveryDetailsDto {
    processingTimeMillis!: number;
    smtpResponse!: string | undefined;
    reportingMta!: string | undefined;
    remoteMtaIp!: string | undefined;
    recipients!: string[];

    constructor(data?: ISesDeliveryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingTimeMillis = _data["processingTimeMillis"];
            this.smtpResponse = _data["smtpResponse"];
            this.reportingMta = _data["reportingMta"];
            this.remoteMtaIp = _data["remoteMtaIp"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
        }
    }

    static fromJS(data: any): SesDeliveryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SesDeliveryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingTimeMillis"] = this.processingTimeMillis;
        data["smtpResponse"] = this.smtpResponse;
        data["reportingMta"] = this.reportingMta;
        data["remoteMtaIp"] = this.remoteMtaIp;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        return data;
    }
}

export interface ISesDeliveryDetailsDto {
    processingTimeMillis: number;
    smtpResponse: string | undefined;
    reportingMta: string | undefined;
    remoteMtaIp: string | undefined;
    recipients: string[];
}

export class SesBounceDetailsDto implements ISesBounceDetailsDto {
    bounceType!: BounceType;
    bounceSubType!: BounceSubType;
    feedbackId!: string | undefined;
    reportingMta!: string | undefined;
    remoteMtaIp!: string | undefined;
    recipients!: BounceRecipientModel[];

    constructor(data?: ISesBounceDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bounceType = _data["bounceType"];
            this.bounceSubType = _data["bounceSubType"];
            this.feedbackId = _data["feedbackId"];
            this.reportingMta = _data["reportingMta"];
            this.remoteMtaIp = _data["remoteMtaIp"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(BounceRecipientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SesBounceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SesBounceDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bounceType"] = this.bounceType;
        data["bounceSubType"] = this.bounceSubType;
        data["feedbackId"] = this.feedbackId;
        data["reportingMta"] = this.reportingMta;
        data["remoteMtaIp"] = this.remoteMtaIp;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISesBounceDetailsDto {
    bounceType: BounceType;
    bounceSubType: BounceSubType;
    feedbackId: string | undefined;
    reportingMta: string | undefined;
    remoteMtaIp: string | undefined;
    recipients: BounceRecipientModel[];
}

export enum BounceType {
    Undefined = 0,
    Permanent = 1,
    Transient = 2,
}

export enum BounceSubType {
    Undefined = 0,
    General = 1,
    NoEmail = 2,
    Suppressed = 3,
    MailboxFull = 4,
    MessageTooLarge = 5,
    ContentRejected = 6,
    AttachmentRejected = 7,
    OnAccountSuppressionList = 8,
}

export class BounceRecipientModel implements IBounceRecipientModel {
    emailAddress!: string | undefined;
    action!: string | undefined;
    status!: string | undefined;
    diagnosticCode!: string | undefined;

    constructor(data?: IBounceRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.action = _data["action"];
            this.status = _data["status"];
            this.diagnosticCode = _data["diagnosticCode"];
        }
    }

    static fromJS(data: any): BounceRecipientModel {
        data = typeof data === 'object' ? data : {};
        let result = new BounceRecipientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["action"] = this.action;
        data["status"] = this.status;
        data["diagnosticCode"] = this.diagnosticCode;
        return data;
    }
}

export interface IBounceRecipientModel {
    emailAddress: string | undefined;
    action: string | undefined;
    status: string | undefined;
    diagnosticCode: string | undefined;
}

export class SesComplaintDetailsDto implements ISesComplaintDetailsDto {
    complaintFeedbackType!: ComplaintFeedbackType;
    arrivalDate!: Date;
    feedbackId!: string | undefined;
    userAgent!: string | undefined;
    recipients!: string[];

    constructor(data?: ISesComplaintDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.complaintFeedbackType = _data["complaintFeedbackType"];
            this.arrivalDate = _data["arrivalDate"] ? new Date(_data["arrivalDate"].toString()) : undefined as any;
            this.feedbackId = _data["feedbackId"];
            this.userAgent = _data["userAgent"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
        }
    }

    static fromJS(data: any): SesComplaintDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SesComplaintDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["complaintFeedbackType"] = this.complaintFeedbackType;
        data["arrivalDate"] = this.arrivalDate ? this.arrivalDate.toISOString() : undefined as any;
        data["feedbackId"] = this.feedbackId;
        data["userAgent"] = this.userAgent;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        return data;
    }
}

export interface ISesComplaintDetailsDto {
    complaintFeedbackType: ComplaintFeedbackType;
    arrivalDate: Date;
    feedbackId: string | undefined;
    userAgent: string | undefined;
    recipients: string[];
}

export enum ComplaintFeedbackType {
    Undefined = 0,
    Abuse = 1,
    AuthFailure = 2,
    Fraud = 3,
    NotSpam = 4,
    Other = 5,
    Virus = 6,
}

export class SesOpenDetailsDto implements ISesOpenDetailsDto {
    ipAddress!: string | undefined;
    userAgent!: string | undefined;

    constructor(data?: ISesOpenDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
        }
    }

    static fromJS(data: any): SesOpenDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SesOpenDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        return data;
    }
}

export interface ISesOpenDetailsDto {
    ipAddress: string | undefined;
    userAgent: string | undefined;
}

export class SesClickDetailsDto implements ISesClickDetailsDto {
    ipAddress!: string | undefined;
    userAgent!: string | undefined;
    link!: string | undefined;

    constructor(data?: ISesClickDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): SesClickDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SesClickDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        data["link"] = this.link;
        return data;
    }
}

export interface ISesClickDetailsDto {
    ipAddress: string | undefined;
    userAgent: string | undefined;
    link: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export enum SesLogType {
    Undefined = "undefined",
    Deliveries = "deliveries",
    Bounces = "bounces",
    Complaints = "complaints",
    Opens = "opens",
    Clicks = "clicks",
}

export class SesLogSearchRequest implements ISesLogSearchRequest {
    id!: number | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    recipient!: string | undefined;
    page!: number | undefined;
    pageSize!: number | undefined;
    bounceType!: BounceType | undefined;
    bounceSubType!: BounceSubType | undefined;
    complaintFeedbackType!: ComplaintFeedbackType | undefined;
    ipAddress!: string | undefined;

    constructor(data?: ISesLogSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.recipient = _data["recipient"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.bounceType = _data["bounceType"];
            this.bounceSubType = _data["bounceSubType"];
            this.complaintFeedbackType = _data["complaintFeedbackType"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): SesLogSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SesLogSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["recipient"] = this.recipient;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["bounceType"] = this.bounceType;
        data["bounceSubType"] = this.bounceSubType;
        data["complaintFeedbackType"] = this.complaintFeedbackType;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface ISesLogSearchRequest {
    id: number | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    recipient: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;
    bounceType: BounceType | undefined;
    bounceSubType: BounceSubType | undefined;
    complaintFeedbackType: ComplaintFeedbackType | undefined;
    ipAddress: string | undefined;
}

export class PagedResultDtoOfTwilioSmsDto implements IPagedResultDtoOfTwilioSmsDto {
    items!: TwilioSmsDto[];
    totalCount!: number;
    page!: number;
    pageSize!: number;

    constructor(data?: IPagedResultDtoOfTwilioSmsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TwilioSmsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTwilioSmsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTwilioSmsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedResultDtoOfTwilioSmsDto {
    items: TwilioSmsDto[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export class TwilioSmsDto implements ITwilioSmsDto {
    messageSid!: string | undefined;
    messageStatus!: string | undefined;
    phone!: string | undefined;
    from!: string | undefined;
    to!: string | undefined;
    body!: string | undefined;
    dateCreated!: Date;
    dateUpdated!: Date | undefined;
    dateSent!: Date | undefined;

    constructor(data?: ITwilioSmsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageSid = _data["messageSid"];
            this.messageStatus = _data["messageStatus"];
            this.phone = _data["phone"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.body = _data["body"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined as any;
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TwilioSmsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioSmsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageSid"] = this.messageSid;
        data["messageStatus"] = this.messageStatus;
        data["phone"] = this.phone;
        data["from"] = this.from;
        data["to"] = this.to;
        data["body"] = this.body;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined as any;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : undefined as any;
        return data;
    }
}

export interface ITwilioSmsDto {
    messageSid: string | undefined;
    messageStatus: string | undefined;
    phone: string | undefined;
    from: string | undefined;
    to: string | undefined;
    body: string | undefined;
    dateCreated: Date;
    dateUpdated: Date | undefined;
    dateSent: Date | undefined;
}

export class TwilioSmsSearchModel implements ITwilioSmsSearchModel {
    messageSid!: string | undefined;
    status!: string[] | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    phone!: string | undefined;
    page!: number | undefined;
    pageSize!: number | undefined;

    constructor(data?: ITwilioSmsSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageSid = _data["messageSid"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.phone = _data["phone"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): TwilioSmsSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioSmsSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageSid"] = this.messageSid;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["phone"] = this.phone;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface ITwilioSmsSearchModel {
    messageSid: string | undefined;
    status: string[] | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    phone: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;
}

export class PagedResultDtoOfTwilioCallDto implements IPagedResultDtoOfTwilioCallDto {
    items!: TwilioCallDto[];
    totalCount!: number;
    page!: number;
    pageSize!: number;

    constructor(data?: IPagedResultDtoOfTwilioCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TwilioCallDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTwilioCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTwilioCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedResultDtoOfTwilioCallDto {
    items: TwilioCallDto[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export class TwilioCallDto implements ITwilioCallDto {
    callSid!: string | undefined;
    status!: string | undefined;
    phone!: string | undefined;
    from!: string | undefined;
    to!: string | undefined;
    durationSeconds!: number | undefined;
    dateCreated!: Date;
    dateUpdated!: Date | undefined;
    notificationId!: string | undefined;
    userId!: string | undefined;

    constructor(data?: ITwilioCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callSid = _data["callSid"];
            this.status = _data["status"];
            this.phone = _data["phone"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.durationSeconds = _data["durationSeconds"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined as any;
            this.notificationId = _data["notificationId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): TwilioCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callSid"] = this.callSid;
        data["status"] = this.status;
        data["phone"] = this.phone;
        data["from"] = this.from;
        data["to"] = this.to;
        data["durationSeconds"] = this.durationSeconds;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined as any;
        data["notificationId"] = this.notificationId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITwilioCallDto {
    callSid: string | undefined;
    status: string | undefined;
    phone: string | undefined;
    from: string | undefined;
    to: string | undefined;
    durationSeconds: number | undefined;
    dateCreated: Date;
    dateUpdated: Date | undefined;
    notificationId: string | undefined;
    userId: string | undefined;
}

export class TwilioCallSearchModel implements ITwilioCallSearchModel {
    callSid!: string | undefined;
    status!: string[] | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    phone!: string | undefined;
    notificationId!: string | undefined;
    page!: number | undefined;
    pageSize!: number | undefined;

    constructor(data?: ITwilioCallSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callSid = _data["callSid"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.phone = _data["phone"];
            this.notificationId = _data["notificationId"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): TwilioCallSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioCallSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callSid"] = this.callSid;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["phone"] = this.phone;
        data["notificationId"] = this.notificationId;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface ITwilioCallSearchModel {
    callSid: string | undefined;
    status: string[] | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    phone: string | undefined;
    notificationId: string | undefined;
    page: number | undefined;
    pageSize: number | undefined;
}

export class DashboardStatsDto implements IDashboardStatsDto {
    dailySentEmailsCount!: number;
    dailyDeliveredEmailsCount!: number;
    weeklySentEmailsCount!: number;
    weeklyDeliveredEmailsCount!: number;

    constructor(data?: IDashboardStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailySentEmailsCount = _data["dailySentEmailsCount"];
            this.dailyDeliveredEmailsCount = _data["dailyDeliveredEmailsCount"];
            this.weeklySentEmailsCount = _data["weeklySentEmailsCount"];
            this.weeklyDeliveredEmailsCount = _data["weeklyDeliveredEmailsCount"];
        }
    }

    static fromJS(data: any): DashboardStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailySentEmailsCount"] = this.dailySentEmailsCount;
        data["dailyDeliveredEmailsCount"] = this.dailyDeliveredEmailsCount;
        data["weeklySentEmailsCount"] = this.weeklySentEmailsCount;
        data["weeklyDeliveredEmailsCount"] = this.weeklyDeliveredEmailsCount;
        return data;
    }
}

export interface IDashboardStatsDto {
    dailySentEmailsCount: number;
    dailyDeliveredEmailsCount: number;
    weeklySentEmailsCount: number;
    weeklyDeliveredEmailsCount: number;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    operationName: string;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any, operationName?: string) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
        this.operationName = operationName ?? '';
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any, operationName?: string): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null, operationName));
}

function anyToText(data: unknown): Observable<string>{
    if (data instanceof Blob) return blobToText(data);
    return new Observable<string>(observer => {
        if (!data) {
            observer.next("");
            observer.complete();
            return;
        }
        observer.next(JSON.stringify(data));
        observer.complete();
    });
}

function blobToText(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            try {
                blob.text().then((blobText: string) => {
                    observer.next(blobText);
                    observer.complete();
                }, err => observer.error(err));
            }
            catch { observer.error(); }
        }
    });
}